import React from 'react';
import PropTypes from 'prop-types';
import {
  PaperSvg,
  FileXLS,
  FilePDF,
} from 'AppSrc/core/components/common/svg-icons';

const fileSVGs = {
  pdf: FilePDF,
  xls: FileXLS,
};

const getSvgForFileType = (fileName) => {

  const fileExtension = fileName.split('.').pop();

  if (!fileExtension) {
    return PaperSvg;
  }

  const FileSvg = fileSVGs[fileExtension];

  if (!FileSvg) {
    return PaperSvg;
  }

  return FileSvg;
};

const SVGForFileType = React.memo(({
  fileName,
}) => {
  const SVG = getSvgForFileType(fileName);
  return <SVG />;
});

SVGForFileType.propTypes = {
  fileName: PropTypes.string,
};

export {
  SVGForFileType,
};
